export default {
  title: 'タイトル',
};
